import { render, staticRenderFns } from "./ProgramDateRange.vue?vue&type=template&id=0546e4f4&scoped=true"
import script from "./ProgramDateRange.vue?vue&type=script&lang=js"
export * from "./ProgramDateRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0546e4f4",
  null
  
)

export default component.exports